import api from './api';

export const collectionsService = {
    getAll: async (params = {}) => {
        // Backward compatibility for calls that just passed activeOnly boolean
        if (typeof params === 'boolean') {
            params = { active_only: params, limit: 1000 };
        }
        const response = await api.get('/collections', { params });
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/collections/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/collections', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/collections/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/collections/${id}`);
        return response.data;
    },

    getProducts: async (id) => {
        const response = await api.get(`/collections/${id}/products`);
        return response.data;
    },

    reorder: async (order) => {
        const response = await api.post('/collections/reorder', { order });
        return response.data;
    },

    updateImage: async (id, cover_image) => {
        const response = await api.put(`/collections/${id}/image`, { cover_image });
        return response.data;
    }
};
